const ENROLL_PERSON_REQUEST_SET = 'ENROLL_PERSON_REQUEST_SET';
const ENROLL_PERSON_REQUEST_REMOVE = 'ENROLL_PERSON_REQUEST_REMOVE';

export {
  ENROLL_PERSON_REQUEST_SET,
  ENROLL_PERSON_REQUEST_REMOVE,
};



// WEBPACK FOOTER //
// ./src/app/actions/enroll-person-request/types.js